
import { mapState, mapGetters } from "vuex";

import printTemplateLayout from "./print-template-layout.vue";
import ConsolidatedLogo from "./print-template-svgs/consolidatedLogo.vue";
import QrCode from "../common/qr-code.vue";
import OrderBarcode from "../reciever/order-barcode.vue";
import KotMarketingQrCode from "../common/kot-marketing-qr-code.vue";
import SwiggyLogo from "./print-template-svgs/swiggyLogo.vue";
import ZomatoLogo from "./print-template-svgs/zomatoLogo.vue";
import WhatsappLogo from "./print-template-svgs/whatsappLogo.vue";
import CancelledImage from "./print-template-svgs/cancelledImage.vue";
export default {
  components: {
    printTemplateLayout,
    QrCode,
    OrderBarcode,
    KotMarketingQrCode,
    SwiggyLogo,
    ConsolidatedLogo,
    ZomatoLogo,
    WhatsappLogo,
    CancelledImage
  },
  props: {
    order: {
      type: Object,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => []
    },
    isConsolidatedPrint: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loadedImages: 0,
      unLoadedImages: 0,
      imageCount: 0
    };
  },
  mounted() {
    this.imageCount =
      this.$refs["kot-template"].querySelectorAll("img.custom-image").length;
    this.checkAndEmitDocumentReady();
  },
  computed: {
    ...mapState("restaurant", ["locationDetails", "businessDetails"]),
    ...mapGetters("restaurant", ["getRestaurantName"]),
    ...mapGetters("reciever", ["getWhatsappConfig"]),
    totalItems() {
      return this.items.reduce((acc, item) => acc + item.quantity, 0);
    },
    showBarcode() {
      return (
        this.getChannelConstObj(this.order.source).name ===
          this.$constants.Channels.SWIGGY.name &&
        !this.order.status == 1 &&
        this.isBarcodeEnabled()
      );
    },
    isOrderFontSmall() {
      return (
        this.getBoolean(this.$ls.get("is-kot-small-font", false)) ||
        this.isSmallPrinter
      );
    },
    isSmallPrinter() {
      return this.$ls.get("printer-type", "md") == "sm";
    },
    isCancelledOrder() {
      return this.source == "orderCancelled";
    }
  },
  methods: {
    isFoodSafetyEnabled() {
      return this.getBoolean(this.$ls.get("health-message", true));
    },
    isBarcodeEnabled() {
      return this.getBoolean(this.$ls.get("print-barcode", false));
    },

    printLogoImage() {
      return this.getBoolean(this.$ls.get("print-logo-image", true));
    },

    checkAndEmitDocumentReady() {
      const totalImages = this.loadedImages + this.unLoadedImages;

      if (totalImages === this.imageCount) {
        this.$emit("document-ready");
      }
    }
  }
};
